import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../group-theme.css';


function Navbar({ nav }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem('user');
    navigate("/group/login");
    toast.success("Logged out successfully");
  }

  return (
    <header className="w-full h-14 border-b border-red-100 bg-white px-6 shadow-sm">
      <div className="flex h-14 items-center justify-between max-w-7xl mx-auto">
        <div className="flex text-center">
          <p className="text-md font-extrabold uppercase tracking-[0.2em] text-[#8F0000]">
            Honda Cars India Limited
          </p>
        </div>

        <div className="flex items-center gap-3">

          {window.screen.width > 768 && (<div className="flex gap-3 items-center">
            {nav?.[0] ? nav?.map((item, i) => {
              return (
                <div key={i} className="flex items-center gap-3">
                  <button className="inline-flex items-center rounded gap-2 px-2 py-2 text-sm font-medium text-slate-700 transition hover:bg-red-50">
                    <span className="text-lg capitalize" onClick={() => navigate(`/group/${item.link}`)}>{item.title}</span>
                  </button>
                </div>
              )
            }) : null}
          </div>)}

          <button className="inline-flex items-center gap-2 px-2 py-2 text-sm font-medium text-slate-700 transition hover:bg-red-50">
            <span className="text-lg">|</span>
          </button>
          <button
            type="button"
            onClick={handleLogout}
            className="inline-flex items-center gap-2 px-2 py-1 text-md font-semibold text-[#8F0000] transition hover:bg-red-50"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
